module.exports = __webpack_public_path__ + "static/img/4.2bd556a7.png";